/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
(function() {
  var referralNote = document.querySelector('[data-action="toggle-referral-note"]');
  if (referralNote){
  	referralNote.addEventListener("click", toggleReferralNote);
  }
  var referralNoteSave = document.querySelector('[data-action="toggle-referral-note-save"]');
  if (referralNoteSave){
    referralNoteSave.addEventListener("click", attributeUpdate);
	referralNoteSave.addEventListener("click", toggleReferralNote);
  }
  var referralNoteSaveOnCart = document.querySelector('#referred-by');
  if(referralNoteSaveOnCart){
  	 referralNoteSaveOnCart.addEventListener("change", attributeUpdate);
  }
})();

document.addEventListener('product:added', function(event) {
  console.log('product added');
  setTimeout(function(){
    var referralNote = document.querySelector('[data-action="toggle-referral-note"]');
    if (referralNote){
      referralNote.addEventListener("click", toggleReferralNote);
    }
    var referralNoteSave = document.querySelector('[data-action="toggle-referral-note-save"]');
    if (referralNoteSave){
      referralNoteSave.addEventListener("click", attributeUpdate);
      referralNoteSave.addEventListener("click", toggleReferralNote);
    }
  }, 500);
});

/*
function toggleReferralNote() {
  var sidebarCart = document.querySelector('#sidebar-cart'),
      noteContainer = document.querySelector('.Cart__OffscreenReferralContainer'),
      cartNote = document.querySelector('#referred-by');

  sidebarCart.classList.toggle('has-note-open');
  sidebarCart.querySelector('.Cart__ReferralButton').innerHTML = cartNote.value !== '' ? 'Update Referral' : 'Add Referral';

  noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');

  sidebarCart.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';

  if (sidebarCart.classList.contains('has-note-open')) {
    var transitionEndListener = function transitionEndListener() {
      sidebarCart.querySelector('#referred-by').focus();
      noteContainer.removeEventListener('transitionend', transitionEndListener);
    };

    noteContainer.addEventListener('transitionend', transitionEndListener);
  }
}
*/

async function setCartAttributes(attributes = {}) {
    const result = await fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            attributes: attributes 
        })
    });

    return result.json();
}

async function attributeUpdate(){
  var attributeValue = document.querySelector('#referred-by').value;
  await setCartAttributes({ Referral: attributeValue })
};